import loadable from '@loadable/component'

export const Person = loadable(() => import('./Person'))
export const Persons = loadable(() => import('./Persons'))
export const PersonCard = loadable(() => import('./PersonCard'))
export type { PersonProps } from './Person'
export type { PersonsProps } from './Persons'
export type { PersonCardProps } from './PersonCard'
export * from './__mocks__/Person.mock'
export { default as NoAnalystResults } from './NoAnalystResults'
